import styled from 'styled-components';

export const NftPropertiesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  text-align: left;
`;

export const NftProperty = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  padding: 16px;
  border: 1px solid var(--v3-black-2);
  border-radius: 16px;
  gap: 45px;
`;

export const NftPropertyTitle = styled.div<{ $isLarge?: boolean }>`
  width: 100%;
  color: var(--v3-blue-5);
  font-weight: 500;
  font-size: ${props => (props.$isLarge ? 18 : 14)}px;
  line-height: ${props => (props.$isLarge ? 24 : 20)}px;
`;

export const NftPropertyNameWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  gap: 2px;
`;

export const NftPropertyName = styled.div<{ $isLarge?: boolean }>`
  flex: 1;
  font-weight: 450;
  font-size: ${props => (props.$isLarge ? 24 : 18)}px;
  line-height: ${props => (props.$isLarge ? 32 : 20)}px;
  color: var(--v3-text-color);
`;

export const NftPropertyRarity = styled.div<{ $isLarge?: boolean }>`
  text-align: right;
  font-weight: 500;
  font-size: ${props => (props.$isLarge ? 24 : 15)}px;
  line-height: ${props => (props.$isLarge ? 32 : 20)}px;
  color: var(--v3-blue-5);
`;
